import React, { useEffect } from 'react';
import {
    FaPlus,
    FaListOl,
    FaDollarSign,
    FaBook,
    FaPlayCircle,
    FaMagic,
} from 'react-icons/fa';

const HelpModal = ({ onClose }) => {
    useEffect(() => {
        const handleEsc = (event) => {
            if (event.key === 'Escape') onClose();
        };
        window.addEventListener('keydown', handleEsc);
        return () => window.removeEventListener('keydown', handleEsc);
    }, [onClose]);

    const steps = [
        {
            title: 'Upload your PDF',
            description: (
                <>
                    Open <em>Upload</em> from the sidebar and drag &amp; drop (or browse for) a PDF up to 25&nbsp;MB.
                </>
            ),
            Icon: FaPlus,
            color: '#F97316',
        },
        {
            title: 'Choose quiz settings',
            description: 'When prompted, pick how many questions you want (1–50) before generation starts.',
            Icon: FaListOl,
            color: '#2563EB',
        },
        {
            title: 'Confirm the point cost',
            description: 'Review the estimated wallet points and confirm to begin processing.',
            Icon: FaDollarSign,
            color: '#059669',
        },
        {
            title: 'Jump into quizzes',
            description: 'After confirming, you\'re taken straight to that document\'s quiz list - start your new attempt or revisit past scores from there.',
            Icon: FaPlayCircle,
            color: '#7C3AED',
        },
        {
            title: 'Explore the library',
            description: 'Use search and sorting to browse all of your documents and quizzes anytime.',
            Icon: FaBook,
            color: '#0EA5E9',
        },
        {
            title: 'Regenerate fresh quizzes',
            description: 'Hit the orange New button anytime to spin up a fresh AI-powered quiz with your updated settings.',
            Icon: FaMagic,
            color: '#F59E0B',
        },
    ];

    return (
        <div className="modal-overlay" role="presentation">
            <div
                className="modal-container help-modal"
                role="dialog"
                aria-modal="true"
                aria-labelledby="help-modal-title"
            >
                <h2 id="help-modal-title">Need a refresher?</h2>
                <p>Here&apos;s how to make the most of QuizAcer:</p>
                <ul>
                    {steps.map(({ Icon, title, description, color }) => (
                        <li key={title}>
                            <Icon size={20} color={color} aria-hidden="true" className="help-modal__icon" />
                            <span className="text-container">
                                <strong>{title}:</strong> {description}
                            </span>
                        </li>
                    ))}
                </ul>
                <button onClick={onClose} className="button confirm-button">Got it!</button>
            </div>
        </div>
    );
};

export default HelpModal;